import type { IntlShape } from 'react-intl';

function fractionDigits(value: number): number {
  if (value >= 100) return 0;
  if (value >= 10) return 1;
  return 2;
}

export function formatQuantity(intl: IntlShape, value: number): string {
  return intl.formatNumber(value, { maximumFractionDigits: fractionDigits(value) });
}

/** A measured distance: one decimal, or two below 10 mm. */
export function formatDistance(intl: IntlShape, millimetres: number): string {
  return intl.formatNumber(millimetres, { maximumFractionDigits: millimetres < 10 ? 2 : 1 });
}

export function formatLength(intl: IntlShape, millimetres: number): string {
  return intl.formatNumber(millimetres, { maximumFractionDigits: 2 });
}

export interface ModelSize {
  x: number;
  y: number;
  z: number;
}

export function formatSize(intl: IntlShape, { x, y, z }: ModelSize, format = formatLength): string {
  return `${format(intl, x)} × ${format(intl, y)} × ${format(intl, z)} mm`;
}

const METRE = 1000;

export function formatSpacing(intl: IntlShape, millimetres: number): string {
  return millimetres >= METRE
    ? `${formatQuantity(intl, millimetres / METRE)} m`
    : `${formatQuantity(intl, millimetres)} mm`;
}
